
import { Component, Prop, Vue } from "vue-property-decorator";
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';;

// Цвета редкостей CS2 / Dota 2 (как в Steam)
const RARITY_COLORS: Record<string, string> = {
  "consumer grade": "b0c3d9",
  "base grade": "b0c3d9",
  common: "b0c3d9",
  "industrial grade": "5e98d9",
  uncommon: "5e98d9",
  "mil-spec grade": "4b69ff",
  "mil-spec": "4b69ff",
  "high grade": "4b69ff",
  rare: "4b69ff",
  restricted: "8847ff",
  remarkable: "8847ff",
  mythical: "8847ff",
  classified: "d32ce6",
  exotic: "d32ce6",
  legendary: "d32ce6",
  covert: "eb4b4b",
  extraordinary: "eb4b4b",
  ancient: "eb4b4b",
  contraband: "e4ae39",
  immortal: "e4ae39",
  arcana: "ade55c"
};

// Скин в ячейке админ-таблицы: миниатюра с цветом редкости, название, фаза/float
@Component
export default class AdminSkinCell extends Vue {
  @Prop() name: string | undefined;
  @Prop() image: string | undefined;
  // Название редкости («Covert») или цвет («eb4b4b»)
  @Prop() rarity: string | undefined;
  @Prop() phase: string | undefined | null;
  @Prop() float: number | undefined | null;
  // Клик по названию копирует его; выключать, если ячейка редактируемая
  @Prop({ default: true }) copyable!: boolean;
  // Компактная строка (список скинов в одной ячейке): меньше картинка, ширина по ячейке
  @Prop({ type: Boolean, default: false }) dense!: boolean;

  onNameClick(event: MouseEvent) {
    if (!this.copyable || !this.name) {
      return;
    }
    // Не даём клику дойти до строки/ячейки (выделение, редактирование)
    event.stopPropagation();
    const name = this.name;
    copyToClipboard(name)
      .then(() =>
        this.$q.notify({
          message: `Скопировано: ${name}`,
          type: "positive",
          timeout: 1200
        })
      )
      .catch(() =>
        this.$q.notify({ message: "Не удалось скопировать", type: "negative" })
      );
  }

  get meta() {
    return [
      this.phase,
      typeof this.float === "number" ? `float ${this.float.toFixed(6)}` : ""
    ]
      .filter(Boolean)
      .join(" · ");
  }

  get rarityStyle() {
    const value = String(this.rarity || "")
      .trim()
      .toLowerCase();
    const hex = /^#?[0-9a-f]{6}$/.test(value)
      ? value.replace("#", "")
      : RARITY_COLORS[value];
    if (!hex) {
      return {};
    }
    const [r, g, b] = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16));
    return {
      background: `radial-gradient(ellipse at center, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.06) 75%)`,
      boxShadow: `inset 0 -2px 0 rgb(${r}, ${g}, ${b})`
    };
  }
}
